import styled from "styled-components";
import colors from "core/resources/theme/colors";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { ButtonProps } from "@chakra-ui/button";
import { FaPlus } from "react-icons/fa";

const ButtonStyled = styled(PrimaryButton)`
  max-width: 21px;
  max-height: 21px;
  min-width: 21px;
  min-height: 21px;
  background: transparent;
  color: ${colors.primary};
  border-radius: 50%;
  border: 2px solid ${colors.primary};
  margin-left: 8px;
  padding: 4px;
  font-size: 10px;

  &:hover {
    color: white;
  }
`;

function ButtonPlus({ ...rest }: ButtonProps) {
  return (
    <ButtonStyled {...rest}>
      <FaPlus />
    </ButtonStyled>
  );
}

export default ButtonPlus;
